<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-8 text-center">
          <v-icon color="success" size="64" class="mb-4">
            mdi-check-circle
          </v-icon>
          
          <v-card-title class="text-h5 mb-4 text-center">
            Пароль успешно изменён
          </v-card-title>
          
          <v-card-text class="text-body-1 mb-4">
            Ваш пароль был успешно изменён. Теперь вы можете войти в систему с новым паролем.
          </v-card-text>
          
          <v-btn
            color="primary"
            size="large"
            variant="elevated"
            :to="'/signin'"
            block
          >
            Перейти к входу
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'PasswordChanged'
}
</script>

<style scoped>
/* Vuetify handles styling, minimal custom styles needed */
</style>
